<template>
  <article class="category flex flex-col">
    <h1
      class="mb-[24px] text-center font-roboto text-[32px] font-medium leading-6 text-specialprojectsection"
    >
      Великие законотворцы России
    </h1>
    <div class="-m-2.5 flex flex-wrap">
      <MainPageCardsReworkedBaseCard
        v-for="(entity, index) in zakonotvorcy"
        :key="`${entity.id}_${index}`"
        :data="entity"
        class="w-full max-w-[100%] p-2.5 sm:max-w-[50%] xl:max-w-[33.33333%]"
        disable-announce
      />
    </div>
  </article>
</template>

<script setup>
const { collectionSlug } = useCollectionSlug('velikie-zakonotvorcy-rossii');

const zakonotvorcy = computed(
  () => collectionSlug?.data?.value?.highlight?.list,
);

useHead({
  title:
    'История РФ: статьи для школьников и студентов | Читать на Федеральном портале Истории России',
  meta: [
    {
      name: 'description',
      content:
        'История Российской Федерации в статьях. Освещаем все вехи российской истории в статьях. Российское военно-историческое общество. Мы знаем правду.',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: `${useHostApp()}/collections/velikie-zakonotvorcy-rossii`,
    },
  ],
});
</script>
